import { IVideoCallCallTime } from "@interfaces/videocall/videocall";
import axiosApiInstance from "@services/custom-axios-instance";
import { generateUrl } from "@services/generateUrl/generateUrl";

export async function getVideoCallStartData(callId: string): Promise<IVideoCallCallTime> 
{
    const url = `${generateUrl()}/videochat-server/time/${callId}`;
    const result = await axiosApiInstance.get<IVideoCallCallTime>(url);
    return result.data;
}

export async function deleteVideoCallStartData(callId: string): Promise<number> 
{
    const url = `${generateUrl()}/videochat-server/time/${callId}`;
    const result = await axiosApiInstance.delete<IVideoCallCallTime>(url);
    return result.status;
}

export async function createVideoCallStartData(callId: string): Promise<number> 
{
    const url = `${generateUrl()}/videochat-server/time`;
    const result = await axiosApiInstance.post(url, {call_id: callId, start_time: new Date()} as IVideoCallCallTime);
    return result.status;
}
